import BuildingService from '@/service/building'
import PublicService from '@/service/public'
import { mapHouseItem } from '@/common/utils/map_view_data'
import { App_User } from '@/data/user_info'

export default {
    data() {
        return {
            show_like_tip: false,
            show_consultant_footer: false,
            general_ratings: {},
            house: {},
            favourite: false,
            current_consultant: {},
            excellent_consultants: []
        }
    },
    methods: {
        async toggleFavourite () {
            await PublicService.follow('Fc::Building', this.building_id, !this.favourite)
            this.favourite = !this.favourite
        },
        hideLikeTip () {
            this.show_like_tip = false
        },
        async getBuilding(building_id) {
            const data = await BuildingService.getBuilding(building_id)
            this.getCurrentConsultant(building_id)
            const { follow_info, general_ratings, is_followed} = data
            this.favourite = Boolean(follow_info && follow_info.id) || Boolean(is_followed)
            this.general_ratings = general_ratings
            this.house = mapHouseItem(data)
        },
        async getCurrentConsultant (building_id) {
            const { share_by_consultant_uid } = App_User
            console.log('-----App_User', App_User)
            const consultant_rids = share_by_consultant_uid || ''
            if (consultant_rids) {
                const current_consultant = await PublicService.getRecommendConsultant({
                    scene: 'building',
                    building_id,
                    consultant_rids
                })
                this.current_consultant = current_consultant
                this.show_consultant_footer = Boolean(current_consultant && current_consultant.id)
            }
        },
        getExcellentConsultant (building_id) {
            BuildingService.excellentConsultants(building_id).then((data) => {
                this.excellent_consultants = data.slice(0, 3)
            })
        }
    }
}
